import Vue from 'vue';

export const ebus = new Vue({
    // methods:{
        // rSayHello(){
        //     console.log('Hello from Root');
        // }
    // }
});